import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { GetSellerListRequestDto } from "../../dtos/get-seller-list-request-dto";
import type { GetSellerListResponseDto } from "../../dtos/get-seller-list-response-dto";
import { UserQueryKeys } from "../../generators/user-query-keys";
import { UserService } from "../../services/user-service";

type UseGetSellerListQueryProps = {
  queryParams: GetSellerListRequestDto;
  options?: Omit<
    UseQueryOptions<GetSellerListResponseDto>,
    "queryKey" | "queryFn"
  >;
};

export const useGetSellerListQuery = ({
  queryParams,
  options
}: UseGetSellerListQueryProps) => {
  return useQuery({
    queryKey: UserQueryKeys.getSellerList(queryParams).queryKey,
    queryFn: async () => {
      return await UserService.getSellerList({ payload: queryParams });
    },
    ...options
  });
};
